import { render, staticRenderFns } from "./PaidFeatures.vue?vue&type=template&id=3b1ee7e4&scoped=true"
import script from "./PaidFeatures.vue?vue&type=script&lang=js"
export * from "./PaidFeatures.vue?vue&type=script&lang=js"
import style0 from "./PaidFeatures.vue?vue&type=style&index=0&id=3b1ee7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ee7e4",
  null
  
)

export default component.exports